export async function getIpAddress() {
    const res = await fetch('https://api.ipify.org?format=json');
    if (res.ok) {
        const data = await res.json();
        return data.ip;
    }else {
        console.error('ERROR getting ip address')
        return null
    }
}